export default __webpack_public_path__ + "static/media/greater.2d5cf737.svg";